import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox, FormControl, ListItemIcon, ListItemText, MenuItem, Select } from '@material-ui/core';
import { getStaticText } from '../../utils/constants';
import './index.scss';

const Dropdown = ({ selectedDemographic, selected, setSelected, demographics, dropDownValue, qbyqData }) => {
    const isAllSelected = selectedDemographic.length > 0 && selected.length === selectedDemographic.length;
    const staticText = getStaticText();
    const { SITE_TEXT } = staticText;
    const { CHOOSE_DEMOGRAPHICS } = SITE_TEXT;

    const MenuProps = {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        },
        getContentAnchorEl: null,
    };

    const styles = {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
    };

    const handleChange = event => {
        const { value } = event.target;
        if (value[value.length - 1] === 'all') {
            setSelected(selected.length === selectedDemographic.length ? [] : selectedDemographic);
            return;
        }
        setSelected(value);
    };

    const getLabelName = optionCode => {
        // If qbyqData is provided (for practice-based dropdowns), get display name from there
        if (qbyqData && Object.keys(qbyqData).length > 0) {
            // Look in parent level first
            if (qbyqData[optionCode] && qbyqData[optionCode].display_name) {
                return qbyqData[optionCode].display_name;
            }

            // Look in children level across all parent keys
            const parentKeys = Object.keys(qbyqData);
            for (let i = 0; i < parentKeys.length; i += 1) {
                const parent = qbyqData[parentKeys[i]];
                if (parent && parent.children && parent.children[optionCode]) {
                    const child = parent.children[optionCode];
                    if (child.display_name) {
                        return child.display_name;
                    }
                }
            }

            // If still not found, return the code itself as fallback
            return optionCode;
        }

        // First, check if the code matches a demographic category itself
        for (let i = 0; i < demographics.length; i += 1) {
            const { code = '', label = '' } = demographics[i];
            if (code === optionCode && label) {
                return label;
            }
        }

        // If dropDownValue is provided, use it to find the specific demographic option
        if (dropDownValue) {
            const demo = demographics.filter(({ code }) => code === dropDownValue)[0] || {};
            const demoOptions = demo.options || [];
            const demoParent = demoOptions.find(({ code = '' }) => code === optionCode) || {};
            const { label = '' } = demoParent;
            if (label) return label;
        }

        // If no dropDownValue, search across all demographics to find the option
        for (let i = 0; i < demographics.length; i += 1) {
            const { options = [] } = demographics[i];
            const demoOption = options.find(({ code = '' }) => code === optionCode);
            if (demoOption && demoOption.label) {
                return demoOption.label;
            }
        }

        // Return the code itself as last resort so we can at least see something
        return optionCode || '';
    };

    return (
        <FormControl>
            {selected.length ? <span className="activeSort" /> : null}
            <Select
                labelId="mutiple-select-label"
                multiple
                value={selected}
                onChange={handleChange}
                renderValue={() => CHOOSE_DEMOGRAPHICS}
                MenuProps={MenuProps}
                displayEmpty
            >
                <MenuItem value="" classes={{ root: 'sortOptions' }}>
                    <em>{CHOOSE_DEMOGRAPHICS}</em>
                </MenuItem>
                <MenuItem
                    value="all"
                    // classes={{
                    //     root: '',
                    // }}
                    style={styles}
                    classes={{ root: 'sortOptions' }}
                >
                    <ListItemIcon>
                        <Checkbox
                            checked={isAllSelected}
                            indeterminate={selected.length > 0 && selected.length < selectedDemographic.length}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Select All" />
                </MenuItem>
                {selectedDemographic.map(code => (
                    <MenuItem key={code} value={code} style={styles} classes={{ root: 'sortOptions' }}>
                        <ListItemIcon>
                            <Checkbox checked={selected.indexOf(code) > -1} />
                        </ListItemIcon>
                        <ListItemText primary={getLabelName(code)} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

Dropdown.propTypes = {
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    selectedDemographic: PropTypes.array.isRequired,
    demographics: PropTypes.array.isRequired,
    dropDownValue: PropTypes.string,
    qbyqData: PropTypes.object,
};

Dropdown.defaultProps = {
    dropDownValue: '',
    qbyqData: null,
};

export default Dropdown;
